import { useJumboTheme } from '@jumbo/hooks';
import Span from '@jumbo/shared/Span';
import { ViewList } from '@mui/icons-material';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { Autocomplete, Box, Button, ButtonGroup, Card, Chip, Divider, Grid, IconButton, Stack, TextField, Typography } from '@mui/material';
import { getObjectListByPropertyApi, putUpdateObjectApi } from 'api/general';
import AddUpdateAgendaDialog from 'app/components/Dialog/AddUpdateAgendaDialog';
import { getLocaleDateWithTimeCustom, getUserFullName, stripHTMLTags, updateSortedAgendaList } from 'app/utils/appHelpers';
import { DECISION, DECISION_FILE } from 'app/utils/constants/customConstant';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setCurrentAgenda, showAgendaSnackbar } from 'stores/meeting';
import Swal from 'sweetalert2';
import config, { agendaCardColor, agendaCardTextColor } from '../../../config';
import AgendaFileDialog from '../Dialog/AgendaFileDialog';
import LoadingPopUp from '../LoadingPopup';
import ReportMenuGroup from '../ReportMenuGroup';
import AgendaReviewListTable from '../Table/AgendaReviewListTable';
import DashboardVoteListTable from '../Table/DashboardVoteListTable';
import CustomTooltip from '../Tooltip/CustomTooltip';

function AgendaCard({ agenda, index, handleAgendaSorting, agendas, maxDecisionNo, minDecisionNo, handleDelete }) {

    const dispatch = useDispatch();
    const [decisionNo, setDecisionNo] = useState(agenda.decisionNo);
    const { data: userList } = useSelector(state => state.user);
    const subjectList = useSelector(state => state.subject.data || []);
    const [agendaobj, setAgendaobj] = useState(agenda);
    const currentMeeting = useSelector((state) => state.meeting.currentMeeting);
    const currentMeetingVoteList = useSelector((state) => state.meeting.currentMeetingVoteList);
    const currentMeetingReviewList = useSelector((state) => state.meeting.currentMeetingReviewList);
    const departmentList = config.departments;
    const { theme } = useJumboTheme();
    const [votesDialogStatus, setVotesDialogStatus] = useState(false);
    const [selectedAgenda, setSelectedAgenda] = useState(agenda);
    const [agendaVoteList, setAgendaVoteList] = useState([]);
    const [reviews, setReviews] = useState([]);
    const currentAgendaList = useSelector((state) => state.meeting.currentAgendaList);
    const [loading, setLoading] = useState(false);
    const [loadingProgress, setLoadingProgress] = useState(false);
    const [agendaFileList, setAgendaFileList] = useState([]);
    const [fileDialogStatus, setFileDialogStatus] = useState(false);

    useEffect(() => {
        setAgendaobj(agenda);
        setDecisionNo(agenda.decisionNo);
        setPendingSubjectId(agenda.subjectId);
        setPendingDepartment(agenda.department);
    }, [agenda]);


    useEffect(() => {
        if (selectedAgenda) {
            setVotesDialogStatus(true);
        }
    }, [selectedAgenda]);

    useEffect(() => {
        let cancelled = false;
        const loadAgendaDetails = async () => {
            setLoading(true);
            const res2 = currentMeetingReviewList.filter((x) => x.decisionId === agenda.id);
            const res3 = currentMeetingVoteList.filter((x) => x.decisionId === agenda.id);
            if (!cancelled) {
                setReviews(res2);
                setAgendaVoteList(res3);
                setLoading(false);
            }
        };
        loadAgendaDetails();
        return () => {
            cancelled = true;
        };
    }, [agenda.id, currentMeetingReviewList, currentMeetingVoteList]);


    useEffect(() => {
        setDecisionNo(agenda.decisionNo);
    }, [agenda.decisionNo]);


    //sıralama fonksiyonlari

    const handleDecisionNoChange = (event) => {
        const newDecisionNo = Number(event.target.value);
        setDecisionNo(newDecisionNo);
    };
    const handleSorting = (index, agenda, upDown) => {

        handleAgendaSorting(index, agenda, upDown)
    };

    const handleKeyDown = async (event) => {
        if (event.key === 'Enter') {



            Swal.fire({
                title: 'İşleminiz gerçekleştiriliyor...',
                html: '<div><CircularProgress /></div>',
                allowOutsideClick: false,
                showConfirmButton: false,
                customClass: {
                    container: 'swal-container-custom'
                },
                didOpen: () => Swal.showLoading()
            });

            const currentDept = agenda.department;

            let filteredAgendas;
            if (agenda.supp === 'Evet') {
                filteredAgendas = currentAgendaList.filter(a => a.supp === 'Evet');
            } else {
                filteredAgendas = currentAgendaList.filter(
                    a => a.subjectId === agenda.subjectId && a.department === currentDept
                );
            }

            const allowedMin = minDecisionNo || (filteredAgendas && filteredAgendas.length ? Math.min(...filteredAgendas.map(a => a.decisionNo)) : 0);
            const allowedMax = maxDecisionNo || (filteredAgendas && filteredAgendas.length ? Math.max(...filteredAgendas.map(a => a.decisionNo)) : 0);
            if (decisionNo < allowedMin || decisionNo > allowedMax) {

                Swal.fire({
                    position: 'center',
                    icon: 'warning',
                    title: `Bu konu için ${decisionNo} karar numarası girilemez. Lütfen ${allowedMin} ile ${allowedMax} arasında bir sayı giriniz.`,
                    showConfirmButton: false,
                    timer: 2500,
                    customClass: {
                        container: 'swal-container-custom'
                    },
                });


                setDecisionNo(agenda.decisionNo);
                return;
            }
            const newAgenda = { ...agenda, decisionNo: Number(decisionNo) };


            dispatch(await updateSortedAgendaList(currentAgendaList, "change", newAgenda, true));

        }
    };

    const handleUpdateClick = (item) => {
        dispatch(setCurrentAgenda(item));
        setAddAgendaDialogStatus(true);
    };


    const closeFileDialog = () => {
        setFileDialogStatus(false);
    };
    const handleFileButtonClick = (agenda) => {
        dispatch(setCurrentAgenda(agenda));
        setFileDialogStatus(true)

        let agendaFiles = [];
        const getAPI = async () => {

            const res = await getObjectListByPropertyApi(DECISION_FILE, "decisionId", agenda.id) // ???? ornek id 13643
            agendaFiles = res.data
            agendaFiles.forEach(element => {
                const user = userList.find(item => item.id === element.adminUserId);
                element.user = user
            });
            setAgendaFileList(agendaFiles)
        };
        getAPI();
    }

    const [addAgendaDialogStatus, setAddAgendaDialogStatus] = useState(false);
    const closeDialog = () => {
        setAddAgendaDialogStatus(false);
        dispatch(setCurrentAgenda(null));
    };


    const handleSelectChange = async (newValues) => {

        Swal.fire({
            title: 'İşleminiz gerçekleştiriliyor...',
            html: '<div><CircularProgress /></div>',
            allowOutsideClick: false,
            showConfirmButton: false,
            customClass: {
                container: 'swal-container-custom'
            },
            didOpen: () => Swal.showLoading()
        });

        const updatedAgenda = {
            ...agendaobj,
            ...newValues
        };
        let user = updatedAgenda.user;
        delete updatedAgenda.user;
        const result = await putUpdateObjectApi(DECISION, updatedAgenda);
        if (result.status) {

            updatedAgenda.user = user;
            setAgendaobj(updatedAgenda);
            dispatch(await updateSortedAgendaList(currentAgendaList, "update", updatedAgenda, true));

            dispatch(showAgendaSnackbar({
                message: `${updatedAgenda.decisionNo} numaralı gündemde değişiklik yapıldı.`,
                severity: 'info'
            }));


        }


    };



    const fontSettings = useSelector((state) => state.meeting.fontSettings);
    const { agendaFontSize, iconFontSize } = fontSettings
    const [pendingSubjectId, setPendingSubjectId] = useState(agendaobj.subjectId);
    const [pendingDepartment, setPendingDepartment] = useState(agendaobj.department);


    return (
            <Card
                elevation={0}
                sx={{
                    // boxShadow: 'none',
                    backgroundColor: agendaCardColor,
                    width: '99%',
                    borderRadius: 5,
                    margin: 1,
                    paddingTop: '20px',
                    border: '1px solid #e0e0e0',
                    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                }}
            >
                <LoadingPopUp open={loading || loadingProgress} />
                <Box
                    sx={{
                        flex: 1,
                        display: 'flex',
                        alignItems: 'center',
                        borderBottom: 2,
                        borderBottomColor: 'divider',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        width: '100%',
                    }}
                >


                    <Grid container spacing={0} sx={{ width: '100%', marginBottom: 1, padding: 0 }}>
                        <Grid item xs={12} md={1} lg={1}>
                            <Grid container sx={{ margin: 0, padding: 0 }}>
                                <Grid item xs={12}>
                                    <ButtonGroup>
                                        <IconButton
                                            onClick={() => handleSorting(index, agenda, 'up')}
                                            disabled={index === 0}
                                        >
                                            <ArrowUpwardIcon sx={{ fontSize: iconFontSize }} />
                                        </IconButton>
                                        <IconButton
                                            onClick={() => handleSorting(index, agenda, 'down')}
                                            disabled={index === agendas.length - 1}
                                        >
                                            <ArrowDownwardIcon sx={{ fontSize: iconFontSize }} />
                                        </IconButton>
                                    </ButtonGroup>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={12} md={1} lg={1}>
                            <TextField
                                value={decisionNo}
                                onChange={handleDecisionNoChange}
                                onKeyDown={handleKeyDown}
                                label="Gündem No"
                                variant="outlined"
                                type="number"
                                size="small"
                                fullWidth
                                disabled={agenda.supp === "Evet"}
                                inputProps={{ min: minDecisionNo, max: maxDecisionNo }}
                                sx={{
                                    width: '80%',
                                    margin: 0,
                                    '& .MuiInputBase-input': { fontSize: agendaFontSize },
                                    '& .MuiInputLabel-root': { fontSize: agendaFontSize },
                                }}
                            />
                            ({agenda.id})
                        </Grid>

                        {/* SUBJECT AUTOCOMPLETE */}
                        <Grid item xs={12} md={3} lg={3}>
                            <Autocomplete
                                sx={{ width: '100%', padding: 0, margin: 0, '& .MuiSelect-select': { height: 'auto', minHeight: 'unset' } }}
                                id="autocomplete-subject"
                                options={subjectList}
                                value={subjectList.find(option => option.id === pendingSubjectId) || null}
                                onChange={(e, newValue) => {
                                    setPendingSubjectId(newValue ? newValue.id : 0);
                                }}
                                onKeyDown={e => {
                                    if (e.key === 'Enter') {
                                        handleSelectChange({ subjectId: pendingSubjectId });
                                    }
                                }}
                                size="small"
                                getOptionLabel={option => option.name}
                                ListboxProps={{ style: { fontSize: agendaFontSize, lineHeight: 1 } }}
                                renderInput={params => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        placeholder="Konu seçiniz"
                                        sx={{ width: '90%' }}
                                        InputProps={{ ...params.InputProps, style: { fontSize: agendaFontSize } }}
                                    />
                                )}
                            />
                        </Grid>

                        {/* DEPARTMENT AUTOCOMPLETE */}
                        <Grid item xs={12} md={4} lg={3}>
                            <Autocomplete
                                multiple
                                sx={{ size: 'medium', width: '100%', padding: 0, margin: 0, '& .MuiSelect-select': { height: 'auto', minHeight: 'unset' } }}
                                id="department-autocomplete"
                                options={departmentList}
                                value={
                                    pendingDepartment
                                        ? departmentList.filter(option => pendingDepartment.split(',').map(dep => dep.trim()).includes(option.name))
                                        : []
                                }
                                onChange={(e, newValue) => {
                                    setPendingDepartment(newValue.length ? newValue.map(v => v.name).join(', ') : '');
                                }}
                                onKeyDown={e => {
                                    if (e.key === 'Enter') {
                                        handleSelectChange({ department: pendingDepartment });
                                    }
                                }}
                                size="small"
                                getOptionLabel={option => option.name}
                                ListboxProps={{ style: { fontSize: agendaFontSize, lineHeight: 1 } }}
                                renderTags={(value, getTagProps) => value.map((option, index) => (
                                    <Chip key={option.name} label={option.name} size="medium" {...getTagProps({ index })} sx={{ fontSize: agendaFontSize, height: '18px', margin: '2px', padding: '2px' }} />
                                ))}
                                renderInput={params => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        sx={{ width: '90%' }}
                                        InputProps={{ ...params.InputProps, style: { fontSize: agendaFontSize, padding: '6px' } }}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item xs={12} md={3} lg={2}>
                            <span style={{ fontSize: agendaFontSize, color: agendaCardTextColor }}>
                                {getLocaleDateWithTimeCustom('tr', agenda.pdate)}
                            </span>
                        </Grid>



                        <Grid item xs={2} md={1} lg={2} >

                            <CustomTooltip
                                placement="top"
                                arrow
                                title={
                                    <React.Fragment>
                                        <div
                                            style={{
                                                width: '100%',
                                                maxWidth: '400px',
                                                // height: '100%',


                                            }}
                                        >
                                            <DashboardVoteListTable agendaVotes={agendaVoteList} otherScroll={false} />
                                        </div>
                                    </React.Fragment>
                                }
                            >
                                <ViewList color="warning" sx={{ marginRight: 3, fontSize: iconFontSize }} />
                            </CustomTooltip>

                            <CustomTooltip
                                placement="top"
                                arrow
                                title={
                                    <React.Fragment>
                                        <div
                                            style={{
                                                width: '100%',
                                                maxWidth: '600px',
                                                maxHeight: '400px',
                                                fontSize: agendaFontSize,
                                                color: 'black',
                                            }}
                                        >
                                            <Grid container direction="column">
                                                <Grid item>
                                                    {(() => {
                                                        const user = userList.find(x => x.id === Number(agenda.adminUserId));

                                                        return (
                                                            <Grid item>
                                                                <strong style={{ color: 'black' }}>Kullanıcı:</strong> {getUserFullName(user)}
                                                            </Grid>
                                                        );
                                                    })()}


                                                </Grid>
                                                <Grid item>
                                                    <strong style={{ color: 'black' }}>Ek Gündem:</strong> {agenda.supp}
                                                </Grid>
                                                <Grid item>
                                                    <strong style={{ color: 'black' }}>İlke Kararı:</strong> {agenda.principle}
                                                </Grid>
                                                <Grid item>
                                                    <strong style={{ color: 'black' }}>Yaysis Id:</strong> {agenda.yaysisMeetingId}
                                                </Grid>
                                                <Grid item>
                                                    <strong style={{ color: 'black' }}>Says Id:</strong> {agenda.saysMeetingId}
                                                </Grid>
                                            </Grid>
                                        </div>
                                    </React.Fragment>
                                }
                            >
                                <ViewList color="info" sx={{ fontSize: iconFontSize }} />
                            </CustomTooltip>
                        </Grid>

                    </Grid>
                </Box>

                <Box
                    sx={{
                        flex: 1,
                        display: 'flex',
                        alignItems: 'center',
                        margin: 0,
                    }}
                >
                    <Stack
                        flex={1}
                        direction="row"
                        divider={<Divider orientation="vertical" flexItem />}
                        spacing={0}
                        pr={2}
                    >
                        <Span sx={{ width: '65%', margin: 0 }}>
                            <Grid container spacing={0} sx={{ margin: 0 }}>
                                <Grid item xs={1} />
                                <Grid item xs={11}>
                                    <Grid item xs={12}>
                                        <Typography color="primary.main" mt={1}
                                            sx={{
                                                fontSize: agendaFontSize,



                                            }}>
                                            Gündem Maddesi  {agenda.supp === "Evet" ? "(Ek Gündem)" : ""}
                                        </Typography>
                                        <Typography sx={{ whiteSpace: 'pre-line', fontSize: agendaFontSize, color: agendaCardTextColor }}>
                                            {stripHTMLTags(agenda.agenda)}

                                        </Typography>

                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography color="primary.main" mt={1} sx={{ fontSize: agendaFontSize }}>
                                            Karar
                                        </Typography>
                                        <Typography sx={{ fontSize: agendaFontSize, whiteSpace: 'pre-line', color: agendaCardTextColor }}>
                                            {stripHTMLTags(agenda.decision)}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Span>

                        <Span sx={{ width: '30%', margin: 0 }}>
                            <Grid container spacing={1} sx={{ marginLeft: '10px' }}>
                                <Grid item xs={12}>
                                    <Grid container alignItems="center" spacing={2}>
                                        <Grid item>
                                            <CustomTooltip
                                                placement="top"
                                                arrow
                                                title={
                                                    <div >
                                                        <AgendaReviewListTable agendaReviews={reviews} />
                                                    </div>
                                                }
                                            >
                                                <Typography
                                                    color="primary.main"
                                                    sx={{
                                                        fontSize: agendaFontSize,
                                                        marginY: 1,
                                                        cursor: 'pointer',
                                                        '&:hover': { color: 'secondary.main' },
                                                    }}
                                                >
                                                    Değerlendirme Sonuçları
                                                </Typography>
                                            </CustomTooltip>
                                        </Grid>
                                    </Grid>





                                    {reviews.length > 0 ? (
                                        (() => {
                                            let totalChars = 0;
                                            const items = [];

                                            for (let i = 0; i < reviews.length; i++) {
                                                const review = reviews[i];
                                                const fullName = getUserFullName(review.user);
                                                const reviewText = review.info

                                                const lineText = `${fullName}: ${reviewText}`;

                                                if (totalChars + lineText.length > 250) {
                                                    const remaining = 250 - totalChars;
                                                    if (remaining > 0) {

                                                        const partialLine = lineText.slice(0, remaining) + "...";
                                                        items.push(
                                                            <Grid container key={i}>
                                                                <Grid item xs={12}>
                                                                    <Typography sx={{ fontSize: agendaFontSize, color: agendaCardTextColor }}>
                                                                        {partialLine}
                                                                    </Typography>
                                                                </Grid>
                                                            </Grid>
                                                        );
                                                    }
                                                    break;
                                                } else {
                                                    items.push(
                                                        <Grid container key={i}>
                                                            <Grid item xs={12}>
                                                                <Typography sx={{ fontSize: agendaFontSize, color: agendaCardTextColor }}>
                                                                    {fullName}
                                                                    <Typography
                                                                        component="span"
                                                                        sx={{ fontSize: agendaFontSize }}
                                                                        fontStyle="italic"
                                                                        color="text.secondary"
                                                                    >
                                                                        : {reviewText}
                                                                    </Typography>
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                    );
                                                    totalChars += lineText.length;
                                                }
                                            }
                                            return items;
                                        })()
                                    ) : (
                                        <Typography sx={{ fontSize: agendaFontSize, color: agendaCardTextColor }} variant="body2">
                                            Değerlendirme yapılmamıştır.
                                        </Typography>
                                    )}




                                </Grid>
                            </Grid>
                        </Span>

                        <Span sx={{ width: '5%', ml: 1, mt: 1 }}>
                            <Grid
                                container
                                spacing={0.5}
                                justifyContent="center"
                                alignItems="center"
                            >
                                <Grid item xs={12}>
                                    <Stack direction="column" spacing={0.5}>
                                        <Button
                                            variant="contained"
                                            size="small"
                                            onClick={() => handleFileButtonClick(agenda)}
                                            sx={{ fontSize: agendaFontSize, padding: '4px' }}
                                        >
                                            Dosyalar
                                        </Button>
                                        <Button
                                            variant="outlined"
                                            size="small"
                                            onClick={() => handleUpdateClick(agenda)}
                                            sx={{ fontSize: agendaFontSize, padding: '4px' }}
                                        >
                                            Güncelle
                                        </Button>
                                        <Button
                                            variant="outlined"
                                            color="error"
                                            size="small"
                                            onClick={() => handleDelete(agenda)}
                                            sx={{ fontSize: agendaFontSize, padding: '4px' }}
                                        >
                                            Sil
                                        </Button>
                                        <Button
                                            variant="outlined"
                                            color="warning"
                                            size="small"
                                            onClick={() => handleDelete(agenda, "pending")}
                                            sx={{ fontSize: agendaFontSize, padding: '4px' }}
                                        >
                                            Askıya Al
                                        </Button>
                                        <ReportMenuGroup meeting={currentMeeting} decisionId={agenda.id} type="agenda" iconType='button' />
                                    </Stack>
                                </Grid>
                            </Grid>
                        </Span>

                    </Stack>
                </Box>

                {
                    fileDialogStatus && (
                        <AgendaFileDialog
                            agendaFileList={agendaFileList}
                            setAgendaFileList={setAgendaFileList}
                            onClose={closeFileDialog}
                            open={fileDialogStatus}
                            selectedAgenda={agenda}
                        />
                    )
                }
                {addAgendaDialogStatus && (
                    <AddUpdateAgendaDialog
                        open={addAgendaDialogStatus}
                        onClose={closeDialog}
                    />
                )}
            </Card >
    );
}
const style = document.createElement('style');
style.innerHTML = `
        .swal-container-custom {
            z-index: 10000 !important;
        }
    `;
document.head.appendChild(style);

export default AgendaCard;

